import * as React from 'react';
import * as s from './TourTooltipDefaultArrow.scss';
import { ArrowPosition } from '../../../../types/assistant-actions';
import { TourTooltipArrowProps } from '../TourTooltipWrapper';

export class TourTooltipDefaultArrow extends React.Component<
  TourTooltipArrowProps
> {
  private readonly positionToClass = {
    [ArrowPosition.Top]: s.top,
    [ArrowPosition.Bottom]: s.bottom,
    [ArrowPosition.Left]: s.left,
    [ArrowPosition.Right]: s.right,
  };

  private get arrowPositionClass() {
    return this.positionToClass[this.props.arrowPosition] || '';
  }

  render() {
    return (
      <div
        className={`${s.tourTooltipDefaultArrow} ${this.arrowPositionClass}`}
      ></div>
    );
  }
}
